<script setup lang="ts">
import type { UploadFeature } from '../../models/upload';
import vuIcon from '@ds/vuekit/src/components/vu-icon.vue';

const props = defineProps<{
  feature: UploadFeature;
}>();
</script>
<template>
  <div class="flex flex-row grid-gap-10px">
    <vu-icon :icon="props.feature.icon" />
    <div class="flex flex-column">
      <b class="title">{{ props.feature.title }}</b>
      <div class="content text-justify">
        {{ props.feature.content }}
      </div>
    </div>
  </div>
</template>
<style lang="css" scoped>
.fonticon {
  font-size: 26px;
}

.title {
  line-height: 19px;
  color: rgb(119, 121, 124);
}

.content {
  line-height: 15px;
  font-size: 13px;
  color: #77797c;
}
</style>
